import { Component, Input, signal } from '@angular/core';
import { environment } from 'src/environments/environment';

/** The project's logo, or its initials on a colour derived from the name when it has none. */
@Component({
  selector: 'app-project-avatar',
  template: `
    @if (logoUrl && !logoFailed()) {
      <img class="avatar avatar--logo" [src]="logoSrc" alt="" (error)="logoFailed.set(true)" data-testid="project-logo" />
    } @else {
      <span class="avatar" [style.--hue]="hue" data-testid="project-initials">{{ initials }}</span>
    }
  `,
  styles: [`
    :host {
      display: block;
      flex: none;
      width: var(--avatar-size, 44px);
      height: var(--avatar-size, 44px);
    }

    .avatar {
      display: grid;
      place-items: center;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      border-radius: 12px;
      font-size: calc(var(--avatar-size, 44px) * 0.34);
      font-weight: 700;
      color: #fff;
      background: linear-gradient(135deg, hsl(var(--hue, 235) 75% 58%), hsl(calc(var(--hue, 235) + 40) 70% 45%));
    }

    .avatar--logo {
      object-fit: contain;
      padding: 4px;
      background: #fff;
      border: 1px solid #e6e8f0;
    }
  `],
  standalone: false
})
export class ProjectAvatarComponent {
  @Input({ required: true }) name = '';
  /** Path on the API host, as the projects API returns it. */
  @Input() logoUrl?: string | null;

  readonly logoFailed = signal(false);

  get logoSrc(): string {
    return `${environment.baseUrl}${this.logoUrl}`;
  }

  get initials(): string {
    const words = this.name.trim().split(/\s+/).filter(Boolean);
    const letters = words.length > 1 ? words[0][0] + words[1][0] : this.name.trim().slice(0, 2);
    return letters.toUpperCase();
  }

  // Stable per-name hue so each project keeps the same avatar colour.
  get hue(): number {
    let h = 0;
    for (const ch of this.name) h = (h * 31 + ch.charCodeAt(0)) % 360;
    return h;
  }
}
